import { Logger } from '@aparajita/capacitor-logger';

const logger = new Logger('CapacitorLogger');

export default logger;
